module.exports = __webpack_public_path__ + "img/sort-numeric-down-alt.27413b2c.svg";